import { EMPTY, concat, from, of, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { actions as authActions } from '../ReduxViewModels/Authentication';
import { actions as noticeActions } from '../ReduxViewModels/Notices';
import { ErrorMessage, sanitizeErrorObject } from './errorHelpers';

/**
 * Adds an error notice to the NoticeManager based on errors.
 */
export const addErrorNotice = (prefix: string, error: any) => {
  error = sanitizeErrorObject(error);
  const context = getErrorContext(error);
  const message = error ? error.message : '';
  return noticeActions.addNotice({
    message: `${prefix} ${message}`,
    severity: 'error',
    additionalDetails: error?.details,
    errorInfo: context,
  });
};

const getErrorContext = (error: ErrorMessage) => {
  if (error) {
    const { apiCallId, serverTime } = error;
    if (apiCallId || serverTime) return { serverTime, id: apiCallId };
  }
};

const camelize = (str: string) =>
  str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => (index === 0 ? word.toLowerCase() : word.toUpperCase()))
    .replace(/\s+/g, '');

export const camelizeObjectKeys = (obj: any) => {
  return Object.entries(obj).reduce((prev, cur) => ({ ...prev, [camelize(cur[0])]: cur[1] }), {});
};

/**
 * Converts successful API calls with errors in them into observable errors. May want cleverer handling later.
 */
export const callApi = (promise: any) =>
  from(promise).pipe(mergeMap((res: any) => (res.Success === false ? throwError(res) : of(res))));

export const catchWithAuthErrors = (errorHandler: any) =>
  catchError((err, source$) => {
    err = sanitizeErrorObject(err);
    let errHandlerResult = typeof errorHandler === 'function' ? errorHandler(err, source$) || EMPTY : EMPTY;

    if (err?.Error?.Code === 401) {
      //HTTP 401 Unauthorized
      errHandlerResult = concat(errHandlerResult, of(authActions.requestFailure(err.Error.Code)));
    }

    return errHandlerResult;
  });
